import React, { useState, useEffect } from 'react';
import { Card, TableContainer, Table, TableRow, TableCell, TableBody, TablePagination } from '@mui/material';
import PropTypes from 'prop-types';
import { firestore } from '../../../../../contexts/FirebaseContext';
import { filter } from 'lodash';
import { UserListHead, UserListToolbar } from '../../../user/list';
import Label from '../../../../Label';
import Scrollbar from '../../../../Scrollbar';
import SearchNotFound from '../../../../SearchNotFound';
// import { sentenceCase } from 'change-case';
import { useTheme } from '@mui/material/styles';
import { fCurrency } from '../../../../../utils/formatNumber';
import { fDate, fDateTime } from '../../../../../utils/formatTime';
import ReportListToolbar from '../../../usuarios/ReportListToolbar';
import { startDate } from '../../../../../constants/estartDate';
import UserBasicInfo from '../../../usuarios/general/UserBasicInfo';
import { nombrePaqRastreo, rastreoPaqueteria } from '../../../../../_apis_/dagpacket-oneRequest';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'title', label: 'Titulo', alignRight: false },
  { id: 'date_time', label: 'Fecha', alignRight: false },
  { id: 'row_area', label: 'Area', alignRight: false },
  { id: 'description', label: 'Descripcion', alignRight: false }
];

// const getPaqueteriName = (name) => {
//     const formatName = name.toLowerCase()

//     switch (formatName) {
//         case value:

//             break;

//         default:
//             break;
//     }
// }

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user?.folio?.toString().toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function TablaRastreo({ rate_provider, trackingNumber, getStatusRastreo = null }) {
  const [rastreoItems, setRastreoItems] = useState([]);
  const [statusSelected, setStatusSelected] = useState(null);
  const theme = useTheme();

  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    async function getRastreoItems() {
      try {
        // const res = await rastreoPaqueteria('ups', '1Z5338FF0107231059');
        // const res = await rastreoPaqueteria('dhl', 7777777770);
        const res = await rastreoPaqueteria(rate_provider, trackingNumber);
        setRastreoItems(res.rows);
        if (getStatusRastreo) {
          getStatusRastreo(res.trackingStatus);
        }
        console.log(res);
      } catch (error) {
        console.error(error.response);
      }
    }
    getRastreoItems();
  }, [getStatusRastreo, rate_provider, trackingNumber]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rastreoItems.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  // const handleDeleteUser = (userId) => {
  //   console.log(userId);
  // };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rastreoItems.length) : 0;

  //   const filterStatus = (data, status) => {
  //     if (status === 'CANCELADO') {
  //       return data.filter((item) => item.status === status);
  //     }
  //     if (status === 'RECHAZADO') {
  //       return data.filter((item) => item.status === status);
  //     }
  //     if (status === 'PENDIENTE') {
  //       return data.filter((item) => item.status === status);
  //     }
  //     if (status === 'APLICADO') {
  //       return data.filter(
  //         (item) => item.status !== 'CANCELADO' && item.status !== 'PENDIENTE' && item.status !== 'RECHAZADO'
  //       );
  //     }
  //     return data;
  //   };

  // const filteredByStatus = statusSelected ? reports.filter((item) => item.status === statusSelected) : reports;
  //   const filteredByStatus = filterStatus(reports, statusSelected);

  const filteredUsers = applySortFilter(rastreoItems, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredUsers.length === 0;

  return (
    <Card>
      {/* <ReportListToolbar
        numSelected={selected.length}
        filterName={filterName}
        onFilterName={handleFilterByName}
        handleStatus={setStatusSelected}
      /> */}
      <Scrollbar>
        <TableContainer>
          <Table>
            <UserListHead
              order={order}
              orderBy={orderBy}
              headLabel={TABLE_HEAD}
              rowCount={rastreoItems.length}
              numSelected={selected.length}
              onRequestSort={handleRequestSort}
              onSelectAllClick={handleSelectAllClick}
              checkboxOption={false}
            />
            <TableBody>
              {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, i) => {
                // const { id, name, email, role, wallet, status = 'active' } = row;
                // reports.map((row) => {
                const { title, date_time, description, row_area } = row;
                // const authorizationDate = authorized_at?.seconds * 1000 || authorized_at;
                // const createDate = created_at?.seconds * 1000 || created_at;
                // const paymentDate = date?.seconds * 1000 || date;
                const isItemSelected = selected.indexOf(i) !== -1;

                // let statusShow;
                // if (status === 'PENDIENTE') {
                //   statusShow = (
                //     <Label variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'} color="info">
                //       Pendiente
                //     </Label>
                //   );
                //   // statusShow = <Chip sx={{ fontSize: '10px' }} label="Pendiente" size="small" color="info" />;
                // } else if (status === 'RECHAZADO') {
                //   statusShow = (
                //     <Label variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'} color="error">
                //       Rechazado
                //     </Label>
                //   );
                // } else if (status === 'CANCELADO') {
                //   statusShow = (
                //     <Label variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'} color="primary">
                //       Cancelado
                //     </Label>
                //   );
                // } else {
                //   statusShow = (
                //     <Label variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'} color="success">
                //       Aplicado
                //     </Label>
                //   );
                // }

                return (
                  <TableRow
                    hover
                    key={i}
                    tabIndex={-1}
                    role="checkbox"
                    selected={isItemSelected}
                    aria-checked={isItemSelected}
                  >
                    <TableCell align="left">{title}</TableCell>
                    <TableCell align="left">{date_time ? fDateTime(date_time) : ''}</TableCell>
                    <TableCell align="left">{row_area}</TableCell>
                    <TableCell align="left">{description}</TableCell>
                  </TableRow>
                );
              })}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
            {isUserNotFound && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                    <SearchNotFound searchQuery={filterName} />
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </Scrollbar>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={filteredUsers.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Card>
  );
}
